import "./grid";

function initializeRatesGrid(elementSelector = false, roomLevelRates = false, roomID = 0) {
    const gridDetails = window.rates.rates_grid_json;

    // Fallback for cases where both the full rates grid and the individual room grids are on the same page
    // (i.e. $this->build_rates_grid_json("ALL") in Establishment.php is used for both the establishment and rooms' grids)
    if (roomLevelRates && 'units' in gridDetails) {
        let unitsJSON = JSON.parse(gridDetails.units)

        unitsJSON.forEach(function (unit) {
            gridDetails[unit.id] = {
                units: unit,
                pax: gridDetails.pax,
                start_day: gridDetails.start_day,
                start_month: gridDetails.start_month,
                start_year: gridDetails.start_year,
                element_hack: `grid-${unit.id}`,
            }
        })
    }

    const gridSelector = elementSelector || '#grid';
    const gridEl = document.querySelector(gridSelector);

    let params
    if (roomLevelRates) {
        const roomJSON = gridDetails[roomID];
        params = {
            units: [roomJSON.units],
            adult: roomJSON.adult,
            start_day: roomJSON.start_day,
            start_month: roomJSON.start_month,
            start_year: roomJSON.start_year,
            element_selector: gridSelector,
            element_hack: roomJSON.element_hack
        }
    } else {
        params = {
            units: JSON.parse(gridDetails.units),
            adult: gridDetails.adult,
            start_day: gridDetails.start_day,
            start_month: gridDetails.start_month,
            start_year: gridDetails.start_year,
            element_selector: gridSelector,
            element_hack: gridDetails.element_hack
        }
    }

    if (gridEl !== null && gridDetails !== null) {
        (function ($) {
            $(gridSelector).grid(params);
        })(jQuery);
    }
}

export { initializeRatesGrid }
